var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"fileUploadInput",attrs:{"type":"file","alt":"File Upload Input","accept":"image/*","hidden":""}})}
var staticRenderFns = []

export { render, staticRenderFns }